export const API_RESPONSE_MESSAGE = "API_RESPONSE_MESSAGE";

export default (state = null, action) => {
    switch (action.type) {
        case API_RESPONSE_MESSAGE:
            return action.payload;
        default:
            return state;
    }
}
